import MetadataManager from './common/MetadataManager';
import { useTranslation } from 'react-i18next';

export default function TypeManagement() {
  const { t } = useTranslation();

  return (
    <MetadataManager
      title={t('settings.typeManagement.title')}
      type="types"
      description={t('settings.typeManagement.description')}
    />
  );
}
